import React, { useEffect } from "react";

import styles from "./slide.module.scss";
import useMeasure from "react-use-measure";
import _ from "lodash";

interface SlideChoiceProps {
  options: {
    label: string;
    value: any;
  }[];
  value: any;
  onChange: (value: any) => void;
}

const SlideChoice: React.FC<SlideChoiceProps> = ({ value, onChange, options }) => {
  const [slideRef, slideBounds] = useMeasure();
  const [ticks, setTicks] = React.useState(0);

  const index = React.useMemo(() => {
    const index = _.findIndex(options, (option) => {
      return option.value === value;
    });
    return index === -1 ? 0 : index;
  }, [value, options]);

  useEffect(() => {
    if (slideBounds.width > 0) {
      setTicks(Math.floor(slideBounds.width / 6));
    }
  }, [slideBounds]);

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    const option = options[value];
    onChange(option.value);
  }

  return (
    <div className={styles.slide}>
      <div className={styles.wrapper} ref={slideRef}>
        <div className={styles.track}>
          {_.times(ticks, (index) => (
            <div key={index} className={styles.tick} />
          ))}
        </div>
        <div className={styles.progress} style={{
            width: `${index * (slideBounds.width / (options.length - 1))}px`,
          }} 
        />
        <input type="range" className={styles.slider}
          min={0} max={_.size(options) - 1}
          value={index}
          onChange={handleSliderChange}
        />
        <div className={styles.options}>
          {options.map((option, index) => {
            const left = index * (slideBounds.width / (options.length - 1));
            return (
              <div key={index} className={styles.option} style={{ left }}>
                {option.label}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}

const Slide = {
  Choice: SlideChoice
}

export default Slide;